import { IonPage, IonRouterOutlet } from "@ionic/react";
import { Redirect, Route, Switch } from "react-router";
import isAuthenticated from "../../../global/utils/isAuthenticated";
import PaginaNoEncontrada from "../../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import AutocheckinProvider from "../context/Provider";
import GlobalInitializeDataCheckIn from "../GlobalInitializeDataCheckIn";
import routes from "./listRoutes";

const RouterAutoCheckin = ({ match }) => {
  return (
    <AutocheckinProvider>
      <GlobalInitializeDataCheckIn>
        <IonPage>
          <IonRouterOutlet>
            <Switch>
              {routes.map((route, key) => {
                return (
                  <Route
                    exact
                    path={`${match.url}${route.path}`}
                    key={key}
                    render={({ props }) =>
                      !isAuthenticated() ? (
                        <Redirect to="/" />
                      ) : (
                        <route.component {...props} />
                      )
                    }
                  />
                );
              })}

              {/*  Aca debe ir la ruta 404  */}
              <Route path="*" component={PaginaNoEncontrada} />
            </Switch>
          </IonRouterOutlet>
        </IonPage>
      </GlobalInitializeDataCheckIn>
    </AutocheckinProvider>
  );
};

export default RouterAutoCheckin;
